// Others
import React, { useState, useEffect } from 'react';
import { getMethod } from '../../../services/apiService';
import LoadingSpinner from '../../../utility/LoadingSpinner';
import 'react-quill/dist/quill.snow.css';
// import '../../../css/reactquill.css';


function Others() {
    const [article, setArticle] = useState(null);
    //get
    useEffect(() => {
        const getOthers = async () => {
            try {
                const response = await getMethod('others');
                console.log("GET====", response);
                if (!response.error && response.data && Array.isArray(response.data.data)) {
                    const first = response.data.data[0];
                    console.log("First Article:", first);
                    setArticle(first || null);
                } else {
                    setArticle(null);
                }
            } catch (error) {
                console.error('Error during fetch others', error);
                setArticle(null);
            }
        };
        getOthers();
    }, []);

    if (!article) return <LoadingSpinner />;

    return (
        <div className="page-others-buyerszone">
            {/* <p
                className="photograph-buyerszone-home__p"
                dangerouslySetInnerHTML={{ __html: article.article_description }}
            /> */}
            <div
                className="photograph-buyerszone-home__p"
                dangerouslySetInnerHTML={{ __html: article.article_description }}
            />

        </div>
    );
}

export default Others;